module.exports = __webpack_public_path__ + "24e6cd0fa7d2b10bafd4531f61b199c4.svg";